/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import productSlugs from '../../productSlugs.json';

/**
 * The product-tile (LOB) slugs that appear as the first URL segment, ahead of the
 * locale/country pair — e.g. `/snap/en/gb`.
 *
 * Sourced from `productSlugs.json` because `next.config.js` needs the same list to
 * build its rewrite/redirect matchers and cannot import TypeScript. Adding a slug
 * here makes it routable; there is nothing else to keep in sync.
 */
export const PRODUCT_TILE_SLUGS: readonly string[] =
  productSlugs.productTileSlugs;

/**
 * Superseded slugs kept only so old URLs can be redirected — e.g. `hotel` was
 * the slug before it became `hotels`. Not routable; see `next.config.js`.
 */
export const LEGACY_SLUG_ALIASES: Readonly<Record<string, string>> =
  productSlugs.legacySlugAliases;

/** Whether a URL segment is one of the routable product-tile slugs. */
export const isProductTileSlug = (segment?: string): boolean =>
  !!segment && PRODUCT_TILE_SLUGS.includes(segment.toLowerCase());
